import { scriptitem } from "./table_typing"

export interface tableState {
    visible: boolean,
    condition: boolean,
    scanmaster:string,
    scanmasterlist:string, //scanmaster[],
    parameterlist:string, //parameterset[],
    itemToDelete: string,
    model:scriptitem[],
    view:{
        loaded: boolean, 
        autorefresh: boolean,
    }
}

export const tableInitialState = {
    visible: false,
    scanmaster:"",
    scanmasterlist:'',// [] as scanmaster[] ,
    parameterlist:'',//[] as parameterset[],
    condition: true,
    itemToDelete: "null",
    model:[] as scriptitem[],
    view:{
        loaded: false,
        autorefresh: false,
    }
    }


export function deepCopyTableThingyState(toCopy:tableState):tableState{
    return {
        visible: false,
        scanmaster:"",
        scanmasterlist:'',//[] as scanmaster[],
        parameterlist:'',//[] as parameterset[],
        condition: true,
        itemToDelete: "null",
        model:toCopy.model,
        view:{
            loaded:toCopy.view.loaded,
            autorefresh:toCopy.view.autorefresh
        }
    }
    
}